module.exports = __webpack_public_path__ + "static/media/YM68_2.f761c9dc.jpg";